export default "__VITE_ASSET__BnwiAIjb__"